import { Component, AfterViewInit, ViewChild, ElementRef } from '@angular/core';
import { GridOptions } from 'ag-grid';
import { Router } from '@angular/router';

import * as encoding from 'encoding-japanese';
import { CARRIERDEVICE, CarrierdeviceService, DEFAULT_FLOOR } from 'app/service/carrierdevice/carrierdevice.service';
import { CommonService } from '../../../service/common/common.service';
import { environment } from '../../../../environments/environment';
import { config } from '../../../util/config';
import { insertcomma } from '../../../util/util';
import { AgGridHelper } from '../../../util/AgGridHelper';
import { from } from 'rxjs/observable/from';

@Component({
  selector: 'app-wa9251',
  templateUrl: './wa9251.component.html',
  styleUrls: ['./wa9251.component.scss']
})
export class Wa9251Component implements AfterViewInit {
  private gridApi: any;
  public componentTitle = 'WA9251:搬送什器マスタ照会';

  public gridOptions: GridOptions;
  public showGrid: boolean;
  public rowData: any[];

  public ownerId: number;
  public ownerResult: any;

  public config = config;

  public working = false;
  public containerHeight = 500;
  public cardHeight = 500;
  public gridHeight = 500;
  public production = environment.production;
  public backgroundColor: string;
  private errorInfo = '';

  @ViewChild('gridView')
  private gridView: ElementRef;
  private gridHelper: AgGridHelper;

  private paginationGetRowCount = 0;
  private paginationGetTotalPages = 0;
  private paginationGetCurrentPage = 0;
  private paginationGoToFirstPage;
  private paginationGoToNextPage;
  private selectedCount = 0;
  private isShowSendLoading = false;

  public rowsPerPageModel = [{ value: 10, viewValue: '10' }, { value: 20, viewValue: '20' }, { value: 100, viewValue: '100' }, { value: 500, viewValue: '500' }];
  public rowsPerPage = config.rowsPerPageSize;

  private isEnableClearFilter = false;
  private isOwnerSearchNone = false;
  private isShowWa9252 = false;
  private isShowWa9253 = false;
  private isShowRemoveModal = false;


  constructor(
    private router: Router, 
    private carrierdeviceService: CarrierdeviceService,
    private commonService: CommonService, 
    ) {
    this.gridHelper = new AgGridHelper();
    this.gridHelper.gridSelectionCheckboxStyle = 'radio';
    this.gridOptions = <GridOptions>{
      rowSelection: 'single',
      floatingFilter: true,
      enableRangeSelection: true,
      localeText: environment.gridLocale,
      getContextMenuItems: this.getContextMenuItems,
      onColumnResized: this.saveColumnWidth,
      pagination: true,
      suppressRowClickSelection: false,
      onColumnMoved: () => {
        this.saveColumnOrder();
      },
      onGridReady: params => {
        this.gridApi = params;
        const columns = [];
        for (const column of params.columnApi.getAllDisplayedColumns()) {
          const idx = localStorage.getItem(`wa9251_${column.getColId()}_idx`);
          if (idx !== null) {
            columns.push({ idx: parseInt(idx, 10), column: column });
          }
        }
        columns.sort((a, b) => {
          return a.idx - b.idx;
        });
        for (let i = columns.length - 1; i >= 0; i--) {
          const column = columns[i];
          params.columnApi.moveColumn(column.column, column.idx);
        }

        this.gridHelper.onGridReady();
        this.gridHelper.renderGridCheckboxImage();
        this.gridOptions.api.paginationSetPageSize(this.rowsPerPage);
      },
      onFilterChanged: () => {
        this.errorInfo = '';
        this.isEnableClearFilter = this.gridOptions.api.isAnyFilterPresent();
        this.gridHelper.onGridFilterChanged();
      },
      onPaginationChanged: () => {
        this.paginationGetRowCount = this.gridOptions.api.paginationGetRowCount();
        this.paginationGetTotalPages = this.gridOptions.api.paginationGetTotalPages();
        if (this.paginationGetRowCount === 0) {
          this.paginationGetCurrentPage = 0;
        } else {
          this.paginationGetCurrentPage = this.gridOptions.api.paginationGetCurrentPage() + 1;
        }
        this.gridHelper.renderScrollArrow();
        this.gridHelper.renderGridCheckboxImage();
      },
      onRowDataChanged: () => {
        this.errorInfo = '';
        this.gridHelper.onRowDataChanged();

        this.selectedCount = 0;
      },
      overlayLoadingTemplate: this.gridHelper.TEMPLATE_GRID_LOADING,
      overlayNoRowsTemplate: this.gridHelper.TEMPLATE_GRID_NODATA,
      postProcessPopup: params => {
        this.errorInfo = '';
        this.gridHelper.fixedAgMenu();
      },
      onSortChanged: () => {
        this.errorInfo = '';
        this.gridHelper.renderGridCheckboxImage();
      },
      onSelectionChanged: () => {
        this.errorInfo = '';
        this.selectedCount = this.gridOptions.api.getSelectedRows().length;
      }
    };
    this.gridOptions.columnDefs = [
      {
        headerName: '',
        headerCheckboxSelection: false,
        headerCheckboxSelectionFilteredOnly: true,
        width: 30,
        checkboxSelection: true,
        suppressSorting: true,
        suppressFilter: true,
        pinned: 'left',
        cellClass: ['tc', 'cl_w', 'noCellFocus']
      },
      {
        headerName: '荷主コード',
        field: 'ownerCd',
        sort: 'asc',
        width: this.getColumnWidth('ownerCd', 200),
        unSortIcon: true,
        suppressMenu: true, cellClass: ['tl', 'cellclass']
      },
      {
        headerName: 'フロア',
        field: 'floorCd',
        width: this.getColumnWidth('floorCd', 140),
        unSortIcon: true,
        suppressMenu: true, cellClass: ['tl', 'cellclass']
      },
      {
        headerName: '什器種類',
        field: 'carrierdevicetypeTx',
        width: this.getColumnWidth('carrierdevicetypeTx', 210), unSortIcon: true,
        suppressMenu: true, cellClass: ['tl', 'cellclass']
      },
      {
        headerName: '什器名',
        field: 'carrierdeviceTx',
        width: this.getColumnWidth('carrierdevicenameTx', 210), unSortIcon: true,
        suppressMenu: true, cellClass: ['tl', 'cellclass']
      },
      {
        headerName: '横(cm)',
        field: 'widthNr',
        width: this.getColumnWidth('widthNr', 80),
        valueFormatter: insertcomma,
        unSortIcon: true,
        suppressMenu: true, cellClass: ['tr', 'cellclass']
      },
      {
        headerName: '奥行き(cm)',
        field: 'depthNr',
        width: this.getColumnWidth('depthNr', 80),
        valueFormatter: insertcomma,
        unSortIcon: true,
        suppressMenu: true, cellClass: ['tr', 'cellclass']
      },
      {
        headerName: '高さ(cm)',
        field: 'heightNr',
        width: this.getColumnWidth('heightNr', 80),
        valueFormatter: insertcomma,
        unSortIcon: true,
        suppressMenu: true, cellClass: ['tr', 'cellclass']
      },
      {
        headerName: '充填率上限(%)',
        field: 'fillinglimitNr',
        width: this.getColumnWidth('fillinglimitNr', 90),
        valueFormatter: insertcomma,
        unSortIcon: true,
        suppressMenu: true, cellClass: ['tr', 'cellclass']
      },
      {
        headerName: '更新日時',
        field: 'updDt',
        width: this.getColumnWidth('updDt', 180),
        unSortIcon: true,
        suppressMenu: true, cellClass: ['tr', 'cellclass']
      },
      {
        headerName: '更新者名',
        field: 'upduserTx',
        width: this.getColumnWidth('upduserTx', 120),
        unSortIcon: true,
        suppressMenu: true, cellClass: ['tl', 'cellclass']
      },
      {
        headerName: '登録日時',
        field: 'addDt',
        width: this.getColumnWidth('addDt', 180),
        unSortIcon: true,
        suppressMenu: true, cellClass: ['tr', 'cellclass']
      },
      {
        headerName: '登録者名',
        field: 'adduserTx',
        width: this.getColumnWidth('adduserTx', 120),
        unSortIcon: true,
        suppressMenu: true, cellClass: ['tl', 'cellclass']
      }
    ];
    this.gridHelper.setGridOptions(this.gridOptions);
    this.containerHeight = window.innerHeight - config.containerheaderMargin;
    this.cardHeight = window.innerHeight - config.headerMargin;
    this.gridHeight = window.innerHeight - config.headerMargin - config.containerButtonDubleMargin;
    this.ownerResult = sessionStorage.getItem('ownerResult');
    if (this.ownerResult !== null) {
      const selectedOwner = JSON.parse(this.ownerResult);
      this.ownerId = selectedOwner.ownerId;
    }
    if (this.production) {
      this.backgroundColor = 'primary';
    } else {
      this.backgroundColor = 'warn';
    }
  }

  getColumnWidth(id: string, def: number): number {
    return parseInt(localStorage.getItem(`wa9251_${id}_width`), 10) || def;
  }

  saveColumnWidth(params) {
    if (params.finished === true && params.type === 'columnResized') {
      localStorage.setItem(`wa9251_${params.column.colId}_width`, params.column.actualWidth);
    }
  }

  saveColumnOrder() {
    let idx = 0;
    for (const column of this.gridApi.columnApi.getAllDisplayedColumns()) {
      if (column.colId !== '0') {
        localStorage.setItem(`wa9251_${column.colId}_idx`, `${idx}`);
      }
      idx++;
    }
  }

  getContextMenuItems(params) {
    const str_to_unicode_array = str => {
      const arr = [];
      for (let i = 0; i < str.length; i++) {
        arr.push(str.charCodeAt(i));
      }
      return arr;
    };

    const download = csvString => {
      // Unicode コードポイントの配列に変換する
      const unicode_array = str_to_unicode_array(csvString);
      // S-JIS コードポイントの配列に変換
      const sjis_code_array = encoding.convert(
        unicode_array, // ※文字列を直接渡すのではない点に注意
        'SJIS', // to
        'UNICODE' // from
      );
      // 文字コード配列をTypedArrayに変換する
      const uint8_array = new Uint8Array(sjis_code_array);
      // 指定されたデータを保持するBlobを作成する
      const blob = new Blob([uint8_array], { type: 'text/csv' });
      // Internet Explorer
      if (window.navigator.msSaveOrOpenBlob) {
        window.navigator.msSaveOrOpenBlob(blob, 'export.csv');
      } else {
        // Chrome
        const downloadLink = document.createElement('a');
        downloadLink.href = window.URL.createObjectURL(blob);
        downloadLink.download = 'export.csv';
        document.body.appendChild(downloadLink);
        downloadLink.click();
        document.body.removeChild(downloadLink);
      }
    };

    const result = [
      'copy',
      'copyWithHeaders',
      'separator',
      {
        name: 'エクスポート',
        subMenu: [
          {
            name: 'チェックした行をCSVエクスポート',
            action: () => {
              download(params.api.getDataAsCsv({ onlySelected: true }));
            }
          },
          {
            name: 'すべてCSVエクスポート',
            action: () => {
              download(params.api.getDataAsCsv());
            }
          },
          'excelExport'
        ]
      }
    ];

    return result;
  }

  onResize(event) {
    this.containerHeight = window.innerHeight - config.containerheaderMargin;
    this.cardHeight = window.innerHeight - config.headerMargin;
  }

  onResizeGrid(event) {
    this.gridHeight = event.target.innerHeight - config.headerMargin - config.containerButtonDubleMargin;
  }

  ngAfterViewInit() {
    this.gridHelper.el = this.gridView;
    setTimeout(() => {
      this.onView();
    }, 500);
  }

  onView() {
    this.onSubmit();
  }

  onSubmit() {
    //SW-2103　ダブルクリック抑止
    if (this.working) return;
    this.working = true;
    this.gridOptions.api.showLoadingOverlay();
    // this.rowData = this.updateData(this.sampleData);
    // this.rowData = []
    this.carrierdeviceService
      .get(this.ownerId)
      .then(outputJson => {
        // パレットの場合は、値を"-"に置き換えて表示する
        this.rowData = this.replaceDataWithDash(outputJson.carrierdevices);
        this.gridHelper.selectedAnimateDelay();
        setTimeout(() => {
          this.gridOptions.api.hideOverlay();
          this.working = false;
        },300);
      })
      .catch(error => {
        console.log(this.commonService.getErrorMessage(error));
        this.errorInfo = this.commonService.getErrorMessage(error);
        this.working = false;
        this.gridOptions.api.hideOverlay();
      });
  }

  insert() {
    this.router.navigate(['wa9252']);
  }

  update() {
    if (this.gridOptions.api.getSelectedNodes().length !== 1) {
      this.errorInfo = '対象を1行だけ選択して下さい';
      return;
    }
    const selectedIndex = this.gridOptions.api.getSelectedNodes()[0]['id'];
    sessionStorage.setItem('rowCase', JSON.stringify(this.rowData[selectedIndex]));
    this.router.navigate(['wa9253']);
  }

  delete() {
    this.isShowSendLoading = true;

    const selectedIndex = this.gridOptions.api.getSelectedNodes()[0]['id'];
    const carrierdeviceId = this.rowData[selectedIndex]['carrierdeviceId'];
    //SW-2097　ダブルクリック抑止
    if (this.working) return;
    this.working = true;
    this.carrierdeviceService
      .delete(carrierdeviceId)
      .then(outputJson => {
        this.working = false;
        if (outputJson.count === 1) {
          sessionStorage.setItem('SuccessInfoMessage', '削除が完了しました');
        }
        this.onSubmit();
        this.isShowRemoveModal = false;
        this.isShowSendLoading = false;
      })
      .catch(error => {
        this.working = false;
        console.log(this.commonService.getErrorMessage(error));
        this.errorInfo = this.commonService.getErrorMessage(error);
        this.isShowSendLoading = false;
        this.isShowRemoveModal = false;
      });

  }

  onFilterClear() {
    this.gridOptions.api.setFilterModel(null);
  }

  paginatorRowChange() {
    this.gridOptions.api.paginationSetPageSize(this.rowsPerPage);
  }

  showWa9252() {
    this.errorInfo = '';
    this.isShowWa9252 = true;
    sessionStorage.removeItem('isShowOwnerSelect');
  }

  onClose9252(isRefreshGrid: boolean) {
    this.isShowWa9252 = false;
    if (isRefreshGrid) this.onSubmit();
    sessionStorage.setItem('isShowOwnerSelect', 'true');
  }

  showWa9253() {
    this.errorInfo = '';
    if (this.gridOptions.api.getSelectedNodes().length !== 1) {
      this.errorInfo = '対象を1行だけ選択して下さい';
      return;
    }
    sessionStorage.setItem('rowCase', JSON.stringify(this.gridOptions.api.getSelectedNodes()[0]['data']));
    this.isShowWa9253 = true;
    sessionStorage.removeItem('isShowOwnerSelect');
  }

  onClose9253(isRefreshGrid: boolean) {
    this.isShowWa9253 = false;
    if (isRefreshGrid) {
      this.gridHelper.prepareSelectedAnimate();
      this.onSubmit();
    }
    sessionStorage.setItem('isShowOwnerSelect', 'true');
  }

  showRemoveModal() {
    this.errorInfo = '';
    if (this.gridOptions.api.getSelectedNodes().length !== 1) {
      this.errorInfo = '対象を1行だけ選択して下さい';
      return;
    }
    this.isShowRemoveModal = true;
  }
  changeOwner(selectedOwnerId) {
    if (selectedOwnerId !== null) {
      if (selectedOwnerId !== undefined) {
        this.ownerId = selectedOwnerId;
      } else {
        this.ownerId = undefined;
      }
      this.onSubmit();
    } else {
      this.ownerId = null;
      this.rowData = [];
      this.gridOptions.api.deselectAll();

    }
  }

  ownerInputChanged(ownerId: string) {
    this.gridHelper.isOwnerNotFound = ownerId == null && ownerId !== undefined;
    this.changeOwner(ownerId);
  }

  /**
   * パレットの場合は、値を"-"に置き換えて表示する
   * フロアコードが空文字の場合には、"デフォルト"に置き換えて表示する
   * 
   * @param carrierdevices 搬送什器マスタデータ
   * @returns 
   */
  replaceDataWithDash(carrierdevices: any[]) {
    return carrierdevices.map((row: any) => {
        let updatedRow = { ...row };
        if (row.carrierdevicetypeCd === CARRIERDEVICE.PALLET.code) {
            updatedRow = {
                ...updatedRow,
                widthNr: '-',
                depthNr: '-',
                heightNr: '-',
                fillinglimitNr: '-'
            };
        }
        if (row.floorCd === '') {
            updatedRow = {
                ...updatedRow,
                floorCd: DEFAULT_FLOOR
            };
        }
        return updatedRow;
    });
}

}



// WEBPACK FOOTER //
// /home/runner/work/saas_wms_prod_ui_pc/saas_wms_prod_ui_pc/src/app/pages/wa9Master/wa9251/wa9251.component.ts